var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"geral","position":"bottom right","classes":"mr-3 mb-3 bg-gradient-dark text-white p-3","type":"bg-gradient-dark"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }